import { useTranslation } from "react-i18next";
import GenericErrorTemplate from "@/components/GenericErrorTemplate";

const Route404 = () => {
  const { t } = useTranslation();

  return (
    <GenericErrorTemplate
      header={t("error.page_not_found")}
      description={t("error.page_not_found_description")}
    />
  );
};

export default Route404;
